<template>
    <SignupLayout>
        <AppHeader slot="header" class="app-header">
            <portal-target name="header-text" />
        </AppHeader>
        <nuxt slot="app" />
        <AppFooter slot="footer" class="app-footer constrained-width">
            <portal-target name="cta-button" />
        </AppFooter>
    </SignupLayout>
</template>

<script>
import {PortalTarget} from 'portal-vue';
import AppHeader from '~/components/AppHeader.vue';
import AppFooter from '~/components/AppFooter.vue';
import SignupLayout from '~/components/SignupLayout.vue';

export default {
    components: {
        AppHeader,
        AppFooter,
        PortalTarget,
        SignupLayout
    }
};
</script>

<style lang="scss" scoped>
@import '~/assets/variables.scss';

.constrained-width {
  width: 100%;
  max-width: $mobile-max-width;
  margin-left: auto;
  margin-right: auto;
}
</style>
